/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

.add-trends-dialog {
  .MuiPaper-root {
    width: 510px;
    height: 530px;
  }

  .center-slash {
    align-items: center;
    display: flex;
    padding-top: 16px;
  }

  .add-trends-dialog-confirmed {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .check-circle {
      width: 52px;
      height: 52px;
    }
  }
}
